import React, {useEffect, ReactElement, useState} from 'react';
import {Permission} from '@shared/services/PermissionService';
import FilterDrawerComponent from '@components/system/FilterDrawer/FilterDrawerComponent';
import {
  Button,
  Radio,
  makeStyles,
  Tooltip,
  IconButton,
  Typography,
  Divider
} from '@material-ui/core';
import Replay from '@material-ui/icons/Replay';
import {useDebouncedCallback} from 'use-debounce';
import {CustomPopOverListItemType} from '@components/system/CustomPopOver/CustomPopOver';
import {ExpandMore, ExpandLess} from '@material-ui/icons';
import CustomPopOver from '@components/system/CustomPopOver/CustomPopOver';
import FilterChipWrapperComponent from '@components/system/FilterChipWrapper/FilterChipWrapperComponent';
import {
  StatementNoticeType,
  StatementNoticeTypeFilter,
  PhoneTypes,
  NOTIFICATION_COUNT_FILTERS,
  PAYMENT_FLOW_FILTERS,
  SEARCH_DEBOUNCE_DELAY,
  OPT_OUT_ELECTRONIC_STATEMENTS_FILTERS,
  paymentPlanStatusArray
} from '@shared/constants/Mapping';
import {Trans, useTranslation} from 'react-i18next';
import {CloseSharp} from '@material-ui/icons';
import {
  APP_PRIMARY_COLOR,
  LIGHT_BLACK_COLOR,
  DEFAULT_BACKGROUND_COLOR,
  BORDER_COLOR
} from 'src/style/variable';
import {AppPermissions} from '@shared/constants/Mapping';
import './PatientStatementsFilterComponentStyles.scss';
import {useSelector} from 'react-redux';
import {checkUnPostedPaymentsExists} from '@shared/services/ClinicServices';
import {SnackBarConfig} from 'src/utils/SnackBarConfig';
import {useSnackbar} from 'notistack';
import FilterChipComponent from '@components/system/FilterDrawer/FilterChipComponent';
import {checkClinicShortCodeExist} from '@shared/utils/HelperUtils';
import ShowCopyLinkDialog from '../../../../../../components/system/ShowLink/ShowLink';
import {formPracticePaymentLink} from 'src/constants/SystemConstants';
import NumberFormat from 'react-number-format';
import StyledOutlinedInput from '@components/system/FormInput/StyledOutlinedInput';
import ConfirmationDialog from '@components/system/ConfirmationDialog/ConfirmationDialog';
import ReloadIcon from '@components/system/ReloadIcon/ReloadIcon';

const DrawerStyles = makeStyles(() => ({
  DateFilterLabels: {
    marginTop: '1.5rem'
  },
  DateFilters: {
    marginTop: '1rem'
  },
  leftDrawer: {
    flex: '1'
  },
  rightDrawer: {
    flex: '1'
  },
  VerticalDrawerDivider: {
    borderRight: `1px solid ${BORDER_COLOR}`,
    margin: '25px 40px 0px 40px',
    height: '100%'
  },
  ClinicFilterHeader: {
    marginTop: '1rem',
    fontSize: '1rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  ClinicFilterHeaderLabels: {
    fontSize: '1rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'pointer',
    '& label': {
      cursor: 'pointer'
    }
  }
}));
const FilterClinicStyles = makeStyles(() => ({
  ClinicMenu: {
    overflow: 'auto',
    '& li': {
      borderBottom: '1px solid #eeeeee'
    },
    '& li:last-child': {
      borderBottom: 'none'
    }
  },
  statementTypeDropdown: {
    width: '300px'
  },
  root: {
    width: '400px',
    '&:focus': {
      outline: 'none'
    }
  },
  ClinicFilterHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '1rem 16px'
  },
  secondary: {
    '& .MuiListItemText-secondary': {
      fontSize: '0.9rem',
      overflow: 'hidden',
      width: '100%',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis'
    }
  },
  primary: {
    '& .MuiListItemText-primary': {
      fontSize: '1.2rem',
      overflow: 'hidden',
      width: '100%',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis'
    }
  },
  clearAll: {
    textTransform: 'capitalize',
    fontSize: '1rem'
  },
  status: {
    backgroundColor: DEFAULT_BACKGROUND_COLOR,
    marginRight: '10px',
    color: APP_PRIMARY_COLOR,
    width: '150px',
    height: '30px',
    display: 'flex',
    justifyContent: 'space-between',
    cursor: 'pointer',
    padding: '0.2rem 0.5rem',
    borderRadius: '3px'
  },
  statement: {
    backgroundColor: DEFAULT_BACKGROUND_COLOR,
    color: APP_PRIMARY_COLOR,
    width: '150px',
    height: '30px',
    display: 'flex',
    justifyContent: 'space-between',
    cursor: 'pointer',
    padding: '0.2rem 0.5rem',
    borderRadius: '3px'
  },
  statusLabelPosition: {
    marginLeft: '5px',
    position: 'relative',
    top: '4px'
  },
  refreshButton: {
    color: LIGHT_BLACK_COLOR
  },
  secondRowStyles: {
    display: 'flex',
    alignItems: 'center',
    '& div': {
      marginRight: '12px',
      width: 'max-content'
    }
  },
  lineHeight: {
    lineHeight: '1rem',
    height: '2.3rem'
  },
  displayFlex: {
    display: 'flex'
  },
  minimumAmount: {
    flex: 1,
    paddingRight: '1rem'
  },
  maximumAmount: {
    flex: 1,
    paddingLeft: '1rem'
  },
  notificationDuration: {
    overflow: 'hidden !important'
  },
  refresh: {
    '& .MuiButtonBase-root': {
      padding: '0.5rem'
    }
  }
}));
interface PatientStatementsFilterComponent {
  setPostedStatus?: any;
  page: number;
  searchInputRef?: any;
  statementType?: any;
  setStatementType?: any;
  handleImportStatementBoolean?: any;
  handleImportFNPDBoolean?: any;
  setPhoneIds?: any;
  phoneIds?: any;
  setSelectedNotificationCount?: any;
  selectedNotificationCount?: any;
  setStatementDueStatus?: any;
  selectedStatementDueStatus?: any;
  setEmailCheck?: any;
  renderSearchFiled?: any;
  guarantorCheckSelect?: any;
  handleImportSummary?: any;
  renderClinicFilters?: any;
  renderDueRequestButton?: any;
  request?: any;
  renderIncludeAllGuarantorCheckBox?: any;
  renderSmsAndEmailCheckBox?: any;
  renderSendButton?: any;
  renderScheduleButton?: any;
  renderDueRequestCancelButton?: any;
  renderDownloadInvoicesButtonAction?: any;
  resetPagesInGrid?: any;
  showFnPdList?(): void;
  selectedClinic: any;
  clinicsList: any;
  handleSendStatements: any;
  handleCustomMessages: any;
  customMessageRequest: boolean;
  renderAddMessageAndSendButton: any;
  renderAddMessageAndScheduleButton: any;
  handleSetFlag: any;
  minimumAmount: any;
  maximumAmount: any;
  setMaximumAmount: any;
  setMinimumAmount: any;
  notificationDuration: any;
  setNotificationDuration: any;
  setOptOutStatement: any;
  selectedOptOutStatement: any;
  handleImportsetVoucherFlag?: any;
  acOfEmrProvider?: any;
  paymentPlanStatus: any;
  setPaymentPlanStatus: any;
  currentGroup: any;
}
const PatientStatementsFilterComponent: React.FC<
  PatientStatementsFilterComponent
> = props => {
  const drawerClasses = DrawerStyles();
  const ClinicClasses = FilterClinicStyles();
  const {
    setStatementType,
    searchInputRef,
    setPostedStatus,
    statementType,
    handleImportStatementBoolean,
    handleImportFNPDBoolean,
    setPhoneIds,
    phoneIds,
    setSelectedNotificationCount,
    selectedNotificationCount,
    setStatementDueStatus,
    selectedStatementDueStatus,
    renderSearchFiled,
    guarantorCheckSelect,
    handleImportSummary,
    renderClinicFilters,
    // renderDueRequestButton,
    request,
    renderIncludeAllGuarantorCheckBox,
    renderSmsAndEmailCheckBox,
    renderSendButton,
    renderScheduleButton,
    renderDueRequestCancelButton,
    renderDownloadInvoicesButtonAction,
    resetPagesInGrid,
    showFnPdList,
    selectedClinic = [],
    clinicsList = [],
    handleSendStatements,
    handleCustomMessages,
    customMessageRequest,
    renderAddMessageAndSendButton,
    renderAddMessageAndScheduleButton,
    handleSetFlag,
    minimumAmount,
    maximumAmount,
    setMaximumAmount,
    setMinimumAmount,
    notificationDuration,
    setNotificationDuration,
    setOptOutStatement,
    selectedOptOutStatement,
    handleImportsetVoucherFlag,
    paymentPlanStatus,
    setPaymentPlanStatus,
    currentGroup
  } = props;
  const [notificationDurationFilter, setNotificationDurationFilter] = useState(
    currentGroup?.notification_to_guarantor?.interval_time
  );

  const userPermissions: any = useSelector(
    (state: any) => state.auth.userPermissions || {}
  );

  const {t} = useTranslation();
  const groupId: any = useSelector((state: any) => state.auth.groupId || null);
  const splitStatement: any = useSelector(
    (state: any) => state.clinics.splitStatement || false
  );
  const selectedClinicId: any = useSelector(
    (state: any) => state.clinics.selectedClinicId || []
  );

  // statementTypeLabel
  const [, setStatementTypeLabel] = React.useState<string>(
    t('DUE_INVOICES.PLACEHOLDERS.STATEMENT_TYPE')
  );

  const [showCopyUrl, setShowCopyUrl] = useState<boolean>(false);

  const clearStatementType = () => {
    setStatementTypeLabel(t('DUE_INVOICES.PLACEHOLDERS.STATEMENT_TYPE'));
    setStatementType('');
  };

  const statementArray = Object.values(StatementNoticeType);

  const phoneHandleMethod = (option: any) => {
    const ids: any = [];
    const labels: any = [];
    ids.push(option.value);
    setPhoneIds(ids);
    labels.push(option.name);
  };

  const [postedStatusLabels, setPostedStatusLabels] = useState<any[]>([]);
  const [openPopover, setPopoverOpen] = useState<boolean>(false);
  const [showConfirmationDialog, setShowConfirmationDialog] =
    useState<boolean>(false);
  const anchorRef = React.useRef<HTMLButtonElement>(null);
  const {enqueueSnackbar} = useSnackbar();
  const [open, setOpen] = useState<boolean>(false);
  //  states for the component
  const [status, setStatus] = useState<any>('');
  const [statement, setStatement] = useState<any>('');

  const [shortCode, setShortCode] = useState<any>('');
  const clearPostedStatus = () => {
    setPostedStatusLabels([]);
    setPostedStatus([]);
  };

  const postedStatusMethod = (option: any) => {
    setPostedStatus([option.value]);
    setPostedStatusLabels([t(option.name)]);
  };

  const onCloseDrawer = () => {
    setOpen(false);
  };
  const handleChangeStatementType = (value: typeof statementArray[0]) => {
    setStatementType(value.key);
    setStatementTypeLabel(value.label);
  };

  const advancedFilter = (): ReactElement => {
    return (
      <div>
        <Button
          color="primary"
          variant="outlined"
          onClick={() => setOpen(true)}
          className={ClinicClasses.lineHeight}
          disabled={!selectedClinicId?.length}>
          {t('PAYMENT_HISTORY.ADVANCED_FILTER')}
        </Button>
      </div>
    );
  };
  const popOverItems =
    splitStatement === false
      ? [
          {
            name: t('DUE_INVOICES.IMPORT_EXPORT_DATA'),
            id: 'IMPORT_STATEMENT',
            permission: AppPermissions.STATEMENT.IMPORT
          },
          {
            name: t('DUE_INVOICES.PREVIOUS_IMPORTS_MENU_LABEL'),
            id: 'LAST_IMPORT_SUMMARY',
            permission: AppPermissions.STATEMENT.LIST
          },
          {
            name: t('DUE_INVOICES.SHOW_FN_PD_DATA'),
            id: 'CHECK_FN_PD_LIST',
            permission: AppPermissions.STATEMENT.IMPORT_FNPD
          },
          {
            name: t('DUE_INVOICES.IMPORT_FN_PD_DATA'),
            id: 'IMPORT_FN/PD',
            permission: AppPermissions.STATEMENT.IMPORT_FNPD
          },
          {
            name: t('DUE_INVOICES.PLACEHOLDERS.REQUEST_DUE'),
            id: 'SEND_REMINDERS',
            permission: AppPermissions.STATEMENT.SEND_REMINDER,
            shouldShow:
              userPermissions?.[groupId]?.['group']?.[
                AppPermissions.MENU_PERMISSIONS.PAYMENTS
              ] === true
          },
          {
            name: t('DUE_INVOICES.PLACEHOLDERS.SEND_CUSTOM_MESSAGES'),
            id: 'SEND_CUSTOM_MESSAGES',
            permission: AppPermissions.STATEMENT.SEND_REMINDER,
            shouldShow:
              userPermissions?.[groupId]?.['group']?.[
                AppPermissions.MENU_PERMISSIONS.PAYMENTS
              ] === true
          },
          {
            name: t('DUE_INVOICES.DOWNLOAD_INVOICES'),
            id: 'DOWNLOAD',
            permission: AppPermissions.STATEMENT.DOWNLOAD
          },
          {
            name: t('PAYMENT_HISTORY.SHARE_PRACTICE_URL'),
            id: 'SHARE_URL',
            permission: AppPermissions.PAYMENT_HISTORY.LIST,
            function: Permission.hasPaymentHistoryPermissions,
            shouldShow:
              userPermissions?.[groupId]?.['group']?.[
                AppPermissions.MENU_PERMISSIONS.PAYMENTS
              ] === true
          }
        ].filter((item: any) => {
          const hasPermission = Permission.hasStatementPermissions(
            userPermissions,
            item.permission,
            groupId
          );
          // If it has shouldShow then check whether it is true or not else no need to check
          if ('shouldShow' in item) {
            return item.shouldShow && hasPermission;
          }
          return hasPermission;
        })
      : [
          {
            name: t('DUE_INVOICES.IMPORT_EXPORT_DATA'),
            id: 'IMPORT_STATEMENT',
            permission: AppPermissions.STATEMENT.IMPORT
          },
          {
            name: t('DUE_INVOICES.PREVIOUS_IMPORTS_MENU_LABEL'),
            id: 'LAST_IMPORT_SUMMARY',
            permission: AppPermissions.STATEMENT.LIST
          },
          {
            name: t('DUE_INVOICES.VOUCHER_MAPPING_LOCATION'),
            id: 'IMPORT_VOUCHER_META',
            permission: AppPermissions.STATEMENT.IMPORT_VOUCHER_META
          },
          {
            name: t('DUE_INVOICES.SHOW_FN_PD_DATA'),
            id: 'CHECK_FN_PD_LIST',
            permission: AppPermissions.STATEMENT.IMPORT_FNPD
          },
          {
            name: t('DUE_INVOICES.IMPORT_FN_PD_DATA'),
            id: 'IMPORT_FN/PD',
            permission: AppPermissions.STATEMENT.IMPORT_FNPD
          },
          {
            name: t('DUE_INVOICES.PLACEHOLDERS.REQUEST_DUE'),
            id: 'SEND_REMINDERS',
            permission: AppPermissions.STATEMENT.SEND_REMINDER,
            shouldShow:
              userPermissions?.[groupId]?.['group']?.[
                AppPermissions.MENU_PERMISSIONS.PAYMENTS
              ] === true
          },
          {
            name: t('DUE_INVOICES.PLACEHOLDERS.SEND_CUSTOM_MESSAGES'),
            id: 'SEND_CUSTOM_MESSAGES',
            permission: AppPermissions.STATEMENT.SEND_REMINDER,
            shouldShow:
              userPermissions?.[groupId]?.['group']?.[
                AppPermissions.MENU_PERMISSIONS.PAYMENTS
              ] === true
          },
          {
            name: t('DUE_INVOICES.DOWNLOAD_INVOICES'),
            id: 'DOWNLOAD',
            permission: AppPermissions.STATEMENT.DOWNLOAD
          },
          {
            name: t('PAYMENT_HISTORY.SHARE_PRACTICE_URL'),
            id: 'SHARE_URL',
            permission: AppPermissions.PAYMENT_HISTORY.LIST,
            function: Permission.hasPaymentHistoryPermissions,
            shouldShow:
              userPermissions?.[groupId]?.['group']?.[
                AppPermissions.MENU_PERMISSIONS.PAYMENTS
              ] === true
          }
        ].filter((item: any) => {
          const hasPermission = Permission.hasStatementPermissions(
            userPermissions,
            item.permission,
            groupId
          );
          // If it has shouldShow then check whether it is true or not else no need to check
          if ('shouldShow' in item) {
            return item.shouldShow && hasPermission;
          }
          return hasPermission;
        });

  const unPostedPaymentsExists = async (): Promise<any> => {
    try {
      if (selectedClinicId && selectedClinicId?.length) {
        const response = await checkUnPostedPaymentsExists({
          clinic_group_id: groupId,
          clinic_id: selectedClinicId[0]
        });
        if (response && Object.keys(response).length) {
          return response?.un_posted_payments_exists;
        }
        return false;
      } else {
        throw new Error(t('DUE_INVOICES.PRACTICE_ID_REQUIRED'));
      }
    } catch (error: any) {
      enqueueSnackbar(error && error?.message, SnackBarConfig('e'));
      throw error;
    }
  };

  const renderConfirmationDialog = () => {
    return (
      <ConfirmationDialog
        open={showConfirmationDialog}
        title={t('DUE_INVOICES.CONFIRM_TO_PROCEED')}
        description={t('DUE_INVOICES.CONFIRM_TO_PROCEED_BODY')}
        confirmButtonText={t('DUE_INVOICES.CONFIRM_YES')}
        cancelButtonText={t('DUE_INVOICES.CONFIRM_NO')}
        onClose={response => {
          if (response === 'confirm') {
            handleImportStatementBoolean(true);
            setShowConfirmationDialog(false);
          } else {
            setShowConfirmationDialog(false);
            handleImportStatementBoolean(false);
          }
        }}
      />
    );
  };
  const handlePopOverItemClick = async (
    item: CustomPopOverListItemType
  ): Promise<any> => {
    if (item.id === 'LAST_IMPORT_SUMMARY') {
      // handleImportSummaryBoolean(true);
      handleImportSummary();
      guarantorCheckSelect();
    } else if (item.id === 'IMPORT_STATEMENT') {
      const exists = await unPostedPaymentsExists();
      if (exists) {
        // SHOW CONFIRMATION DIALOG IF UNPOSTED PAYMENTS EXISTS
        setShowConfirmationDialog(true);
      } else {
        setShowConfirmationDialog(false);
        handleImportStatementBoolean(true);
      }
    } else if (item.id === 'IMPORT_VOUCHER_META') {
      handleImportsetVoucherFlag(true);
    } else if (item.id === 'IMPORT_FN/PD') {
      handleImportFNPDBoolean(true);
    } else if (item.id === 'DOWNLOAD') {
      renderDownloadInvoicesButtonAction();
    } else if (item.id === 'SHARE_URL') {
      if (!selectedClinic.length) {
        enqueueSnackbar(
          t('PAYMENT_HISTORY.SELECT_PRACTICE'),
          SnackBarConfig('e')
        );
        return;
      }

      // checking practice have short code added.
      const praciticeShortCode = checkClinicShortCodeExist(
        clinicsList,
        selectedClinic
      );
      if (!praciticeShortCode) {
        enqueueSnackbar(t('SHORT_CODE_WARNING'), SnackBarConfig('e'));
        return;
      } else {
        setShortCode(praciticeShortCode);
      }

      setShowCopyUrl(true);
    } else if (item.id === 'CHECK_FN_PD_LIST') {
      if (typeof showFnPdList === 'function') {
        showFnPdList();
      }
    } else if (item.id === 'SEND_REMINDERS') {
      if (typeof handleSendStatements === 'function') {
        handleSendStatements();
      }
    } else if (item.id === 'SEND_CUSTOM_MESSAGES') {
      if (typeof handleCustomMessages === 'function') {
        handleCustomMessages();
      }
    }
  };

  const renderPopOverItems = (): ReactElement => {
    return (
      <CustomPopOver
        open={openPopover}
        anchorEl={anchorRef.current}
        listItems={popOverItems}
        position="bottom-end"
        handleClose={() => {
          setPopoverOpen(false);
        }}
        handleListItemClick={(item: any) => handlePopOverItemClick(item)}
      />
    );
  };

  const renderMoreButton = (): ReactElement => {
    return (
      <div className="moreOptions">
        <Button
          color="primary"
          variant="outlined"
          endIcon={
            openPopover ? (
              <ExpandLess style={{marginBottom: '2px'}} />
            ) : (
              <ExpandMore style={{marginBottom: '2px'}} />
            )
          }
          ref={anchorRef}
          onClick={() => setPopoverOpen(true)}
          className={ClinicClasses.lineHeight}
          disabled={!selectedClinicId?.length}>
          {t('PAYMENT_HISTORY.OPTIONS')}
        </Button>
      </div>
    );
  };

  // defining states coming from redux
  const ApplyFilters = (): void => {
    if (selectedClinicId.length) {
      resetPagesInGrid();
      // getPayments(groupId, acOfClinics[0]);
    } else {
      enqueueSnackbar(t('DUE_INVOICES.SELECT_A_CLINIC'), SnackBarConfig('e'));
    }
  };
  const renderApplyFilter = () => {
    ApplyFilters();
  };

  const ResetFilters = (): void => {
    (searchInputRef.current as any).value = '';
    setStatementType('');
    setStatementDueStatus([]);
    setPhoneIds([]);
    setSelectedNotificationCount([]);
    setStatementTypeLabel(t('DUE_INVOICES.PLACEHOLDERS.STATEMENT_TYPE'));
    setMinimumAmount('');
    setMaximumAmount('');
    setNotificationDuration('');
    setNotificationDurationFilter('');
    setOptOutStatement([]);
    setPaymentPlanStatus({});
  };

  const renderResetFilter = () => {
    ResetFilters();
  };

  const clearPhoneFilter = () => {
    setPhoneIds([]);
  };

  const renderRefreshButton = () => {
    return (
      <div className={ClinicClasses.refresh}>
        <ReloadIcon
          title={t('DUE_INVOICES.REFRESH_DATA')}
          onClick={() => {
            handleSetFlag();
            ApplyFilters();
          }}
          disabled={!selectedClinicId.length}
          fontSize="large"
          dataTestId="pcl-statements-refreshGrid"
        />
      </div>
    );
  };

  useEffect(() => {
    setNotificationDurationFilter(
      currentGroup?.notification_to_guarantor?.interval_time
    );
  }, [currentGroup]);
  // debouncing amount
  const debounced = useDebouncedCallback(
    // function
    text => {
      if (!text || text.length >= 1) {
        ApplyFilters();
      }
    },
    // delay in ms
    SEARCH_DEBOUNCE_DELAY
  );

  return (
    <div>
      <div className={'pending-search-filter-main-view'}>
        <span className={'search-filter-main-view-filters'}>
          {renderClinicFilters()}
          {renderSearchFiled()}
          {/* {renderStatementTypeFilters()} */}
          {advancedFilter()}
          {renderRefreshButton()}
        </span>
        <span className={'search-filter-main-view-more-button'}>
          {/* {Permission.hasStatementPermissions(
            userPermissions,
            AppPermissions.STATEMENT.IMPORT_FNPD,
            groupId
          ) && (
            <Button
              variant={'outlined'}
              color="primary"
              className={ClinicClasses.lineHeight}
              onClick={() => {
                if (typeof showFnPdList === 'function') {
                  showFnPdList();
                }
              }}>
              {t('DUE_INVOICES.SHOW_FN_PD_DATA')}
            </Button>
          )} */}
          {/* {!request
            ? (Permission.hasStatementPermissions(
                userPermissions,
                AppPermissions.STATEMENT?.SEND_REMINDER,
                groupId
              ) as any) && renderDueRequestButton()
            : ''} */}
          {
            // (Permission.hasPaymentHistoryPermissions(
            //   userPermissions,
            //   AppPermissions.PAYMENT_HISTORY.DOWNLOAD,
            //   groupId
            // ) as any) &&
            renderMoreButton()
          }
        </span>
        {renderPopOverItems()}
      </div>
      {/* Show reset filter only if both from and to dates are entered */}
      {(postedStatusLabels.length !== 0 ||
        statementType !== '' ||
        phoneIds.length !== 0 ||
        selectedNotificationCount.length !== 0 ||
        selectedStatementDueStatus.length !== 0 ||
        selectedOptOutStatement.length !== 0 ||
        maximumAmount ||
        minimumAmount ||
        notificationDuration ||
        !!Object.keys(paymentPlanStatus).length) && (
        <div className={'second-row-buttons-wrap'}>
          <FilterChipWrapperComponent
            style={{
              height:
                status ||
                statement ||
                phoneIds ||
                selectedNotificationCount ||
                selectedStatementDueStatus
                  ? '3rem'
                  : '0px'
            }}>
            {status && postedStatusMethod && postedStatusLabels.length !== 0 && (
              <span
                onClick={(): void => {
                  clearPostedStatus();
                  setStatus('');
                }}
                className={ClinicClasses.status}>
                <span className={ClinicClasses.statusLabelPosition}>
                  {status}
                </span>
                <span>
                  <CloseSharp />
                </span>
              </span>
            )}
            {selectedClinicId.length !== 0 &&
              PhoneTypes.filter(p => phoneIds.includes(p.value)).map(p => {
                return (
                  <FilterChipComponent
                    key={p.value}
                    value={t(p.name)}
                    onRemove={clearPhoneFilter}
                  />
                );
              })}
            {selectedClinicId.length !== 0 &&
              selectedNotificationCount.map((p: any) => {
                return (
                  <FilterChipComponent
                    key={p.value}
                    value={t(p.label)}
                    onRemove={(): void => {
                      setSelectedNotificationCount([]);
                    }}
                  />
                );
              })}
            {selectedClinicId.length !== 0 &&
              selectedStatementDueStatus.map((p: any) => {
                return (
                  <FilterChipComponent
                    key={p.value}
                    value={t(p.label)}
                    onRemove={(): void => {
                      setStatementDueStatus([]);
                    }}
                  />
                );
              })}
            {selectedClinicId.length !== 0 &&
              StatementNoticeTypeFilter.filter(p =>
                statementType.includes(p.key)
              ).map(p => {
                return (
                  <FilterChipComponent
                    key={p.key}
                    value={t(p.label)}
                    onRemove={(): void => {
                      clearStatementType();
                    }}
                  />
                );
              })}

            {selectedClinicId.length !== 0 &&
              selectedOptOutStatement.map((optOutStatement: any) => {
                return (
                  <FilterChipComponent
                    key={optOutStatement.value}
                    value={t('DUE_INVOICES.' + optOutStatement.text)}
                    onRemove={(): void => {
                      setOptOutStatement([]);
                    }}
                  />
                );
              })}

            {selectedClinicId.length !== 0 && minimumAmount && !maximumAmount && (
              <FilterChipComponent
                key={minimumAmount}
                value={t('DUE_INVOICES.STATEMENT_MINIMUM_AMOUNT', {
                  amount: minimumAmount
                })}
                onRemove={(): void => {
                  setMinimumAmount('');
                }}
              />
            )}
            {selectedClinicId.length !== 0 && maximumAmount && !minimumAmount && (
              <FilterChipComponent
                key={maximumAmount}
                value={t('DUE_INVOICES.STATEMENT_MAXIMUM_AMOUNT', {
                  amount: maximumAmount
                })}
                onRemove={(): void => {
                  setMaximumAmount('');
                }}
              />
            )}
            {selectedClinicId.length !== 0 && notificationDuration && (
              <FilterChipComponent
                key={notificationDuration}
                value={t('DUE_INVOICES.NO_NOTIFICATION_SENT_IN_LAST_DAYS', {
                  days: notificationDuration
                })}
                onRemove={(): void => {
                  setNotificationDuration('');
                  setNotificationDurationFilter('');
                }}
              />
            )}

            {selectedClinicId.length !== 0 && minimumAmount && maximumAmount && (
              <FilterChipComponent
                key={minimumAmount - maximumAmount}
                value={t('DUE_INVOICES.STATEMENT_MINIMUM_MAXIMUM_AMOUNT', {
                  minimumamount: minimumAmount,
                  maximumamount: maximumAmount
                })}
                onRemove={(): void => {
                  setMinimumAmount('');
                  setMaximumAmount('');
                }}
              />
            )}

            {paymentPlanStatus?.label && (
              <FilterChipComponent
                key={paymentPlanStatus.value}
                value={`${t('PAYMENT_PLANS.PAYMENT_PLAN')}: ${
                  paymentPlanStatus.label
                }`}
                onRemove={(): void => {
                  setPaymentPlanStatus({});
                }}
              />
            )}

            {(selectedClinicId.length !== 0 ||
              (selectedClinicId.length !== 0 && minimumAmount) ||
              (selectedClinicId.length !== 0 && maximumAmount) ||
              (selectedClinicId.length !== 0 && notificationDuration) ||
              (status && postedStatusLabels.length !== 0)) && (
              <span className={'second-rows-labels'}>
                <Tooltip title={'Reset Filter'}>
                  <IconButton
                    className={ClinicClasses.refreshButton}
                    onClick={(): void => {
                      setMinimumAmount('');
                      setMaximumAmount('');
                      ResetFilters();
                      setOptOutStatement([]);
                      clearStatementType();
                      setStatementDueStatus([]);
                      setSelectedNotificationCount([]);
                      clearPhoneFilter();
                    }}>
                    <Replay />
                  </IconButton>
                </Tooltip>
              </span>
            )}
          </FilterChipWrapperComponent>
        </div>
      )}
      {request && (
        <div className="request-section-main-view">
          {[
            renderIncludeAllGuarantorCheckBox(),
            renderSmsAndEmailCheckBox(),
            !customMessageRequest && renderSendButton(),
            !customMessageRequest && renderScheduleButton(),
            customMessageRequest && renderAddMessageAndSendButton(),
            customMessageRequest && renderAddMessageAndScheduleButton(),
            renderDueRequestCancelButton()
          ]}
        </div>
      )}
      {
        <FilterDrawerComponent
          title={t('PAYMENT_HISTORY.FILTER_BY_DRAWER')}
          open={open}
          onClose={onCloseDrawer}
          onResetFilter={renderResetFilter}
          onApplyFilter={renderApplyFilter}>
          <div
            className="filterDrawerWidth"
            data-test-id="pcl-statements-pendingFilterDrawer">
            <div className={drawerClasses.leftDrawer}>
              {/* STATEMENT TYPE FILTERS */}
              <div className={drawerClasses.ClinicFilterHeader}>
                <b>{t('DUE_INVOICES.PLACEHOLDERS.STATEMENT_TYPE')}</b>
                <Button
                  className={ClinicClasses.clearAll}
                  data-test-id="pcl-statements-clearAllStatementsType"
                  onClick={(): void => {
                    clearStatementType();
                  }}>
                  {t('COMMON.CLEAR_ALL')}
                </Button>
              </div>

              <div className={ClinicClasses.ClinicMenu}>
                {StatementNoticeTypeFilter.map((notice: any, i) => (
                  <div
                    key={i}
                    className={drawerClasses.ClinicFilterHeaderLabels}>
                    <label htmlFor={`statement-type-filters-${i}`}>
                      {t(notice.label)}
                    </label>
                    <Radio
                      id={`statement-type-filters-${i}`}
                      data-test-id={`pcl-statements-statementsType-${i}`}
                      onClick={(): void => {
                        handleChangeStatementType(notice);
                        setStatement(t(notice.label));
                      }}
                      checked={statementType === notice.key}
                    />
                  </div>
                ))}
              </div>
              {/* Payment Plan Filters Start */}

              <div className={drawerClasses.ClinicFilterHeader}>
                <b>{t('PAYMENT_PLANS.PAYMENT_PLAN')}</b>
                <Button
                  className={ClinicClasses.clearAll}
                  data-test-id="pcl-statements-clearAllPaymentPlan"
                  onClick={(): void => {
                    setPaymentPlanStatus({});
                  }}>
                  {t('COMMON.CLEAR_ALL')}
                </Button>
              </div>

              <div className={ClinicClasses.ClinicMenu}>
                {paymentPlanStatusArray.map((plan: any, i) => (
                  <div
                    key={i}
                    className={drawerClasses.ClinicFilterHeaderLabels}>
                    <label htmlFor={`payment-flow-filters-${i}`}>
                      {t(plan.name)}
                    </label>
                    <Radio
                      id={`payment-flow-filters-${i}`}
                      data-test-id={`pcl-statements-paymentPlan-${i}`}
                      onClick={(): void => {
                        setPaymentPlanStatus({
                          value: plan.value,
                          label: t(plan.name)
                        });
                      }}
                      checked={plan.value === paymentPlanStatus?.value}
                    />
                  </div>
                ))}
              </div>

              <div className={drawerClasses.ClinicFilterHeader}>
                <b>
                  {t(
                    'DUE_INVOICES.PLACEHOLDERS.NO_NOTIFICATION_SENT_IN_LAST_DAYS'
                  )}
                </b>
                <Button
                  className={ClinicClasses.clearAll}
                  data-test-id="pcl-statements-clearAllNotification"
                  onClick={(): void => {
                    setNotificationDuration('');
                    setNotificationDurationFilter('');
                  }}>
                  {t('COMMON.CLEAR_ALL')}
                </Button>
              </div>
              <div
                className={[
                  ClinicClasses.ClinicMenu,
                  ClinicClasses.notificationDuration
                ].join(' ')}>
                <NumberFormat
                  value={notificationDuration || notificationDurationFilter}
                  onChange={event => {
                    setNotificationDuration(
                      event.target?.value?.replace(/\$/g, '').replace(/,/g, '')
                    );
                    setNotificationDurationFilter('');
                    debounced(event.target?.value);
                  }}
                  customInput={StyledOutlinedInput}
                  placeholder={t('DUE_INVOICES.NOTIFICATION_DURATION_DAYS')}
                  margin={'dense'}
                />
              </div>

              <div className={drawerClasses.ClinicFilterHeader}>
                <b>{t('DUE_INVOICES.PLACEHOLDERS.NOTIFICATION_COUNT')}</b>
                <Button
                  className={ClinicClasses.clearAll}
                  data-test-id="pcl-statements-clearAllNotificationCount"
                  onClick={(): void => {
                    setSelectedNotificationCount([]);
                  }}>
                  {t('COMMON.CLEAR_ALL')}
                </Button>
              </div>
              <div className={ClinicClasses.ClinicMenu}>
                {NOTIFICATION_COUNT_FILTERS.map((notification: any, i) => (
                  <div
                    key={i}
                    className={drawerClasses.ClinicFilterHeaderLabels}>
                    <label htmlFor={`notification-count-filters-${i}`}>
                      {t(notification.label)}
                    </label>
                    <Radio
                      id={`notification-count-filters-${i}`}
                      data-test-id={`pcl-statements-notificationCount-${i}`}
                      onClick={(): void => {
                        setSelectedNotificationCount([notification]);
                      }}
                      checked={
                        !!selectedNotificationCount.find(
                          (sNotification: any) =>
                            sNotification.label === notification.label
                        )
                      }
                    />
                  </div>
                ))}
              </div>
              <div className={drawerClasses.ClinicFilterHeader}>
                <b>{t('DUE_INVOICES.PLACEHOLDERS.PHONE_TYPE')}</b>
                <Button
                  className={ClinicClasses.clearAll}
                  data-test-id="pcl-statements-clearAllPhoneType"
                  onClick={clearPhoneFilter}>
                  {t('COMMON.CLEAR_ALL')}
                </Button>
              </div>
              <div className={ClinicClasses.ClinicMenu}>
                {PhoneTypes.map((phone: any, i) => (
                  <div
                    key={phone.value}
                    className={drawerClasses.ClinicFilterHeaderLabels}>
                    <label htmlFor={`phone-ids-${i}`}>{t(phone.name)}</label>
                    <Radio
                      id={`phone-ids-${i}`}
                      data-test-id={`pcl-statements-phoneType-${i}`}
                      onClick={(): void => {
                        phoneHandleMethod(phone);
                      }}
                      checked={phoneIds.indexOf(phone.value) > -1}
                    />
                  </div>
                ))}
              </div>
            </div>
            <Divider
              orientation="vertical"
              className={[drawerClasses.VerticalDrawerDivider].join(' ')}
            />
            <div className={drawerClasses.rightDrawer}>
              <div className={drawerClasses.ClinicFilterHeader}>
                <b>{t('DUE_INVOICES.STATEMENT_AMOUNT')}</b>
                <Button
                  className={ClinicClasses.clearAll}
                  onClick={(): void => {
                    setMinimumAmount('');
                    setMaximumAmount('');
                  }}>
                  {t('COMMON.CLEAR_ALL')}
                </Button>
              </div>

              {/* INPUT AMOUNT SECTION */}
              <div className={ClinicClasses.displayFlex}>
                {/* Minimum amount field. */}
                <div className={ClinicClasses.minimumAmount}>
                  <Typography>{t('DUE_INVOICES.MINIMUM_AMOUNT')}</Typography>
                  <NumberFormat
                    value={minimumAmount}
                    onChange={event => {
                      setMinimumAmount(
                        event.target?.value
                          ?.replace(/\$/g, '')
                          .replace(/,/g, '')
                      );
                      debounced(event.target?.value);
                    }}
                    customInput={StyledOutlinedInput}
                    thousandSeparator={true}
                    prefix={'$'}
                    placeholder={t('DUE_INVOICES.MINIMUM_AMOUNT')}
                    margin={'dense'}
                  />
                </div>

                {/* maximum amount Filed. */}
                <div className={ClinicClasses.maximumAmount}>
                  <Typography>{t('DUE_INVOICES.MAXIMUM_AMOUNT')}</Typography>
                  <NumberFormat
                    value={maximumAmount}
                    onChange={event => {
                      setMaximumAmount(
                        event.target?.value
                          ?.replace(/\$/g, '')
                          .replace(/,/g, '')
                      );
                      debounced(event.target?.value);
                    }}
                    customInput={StyledOutlinedInput}
                    thousandSeparator={true}
                    prefix={'$'}
                    placeholder={t('DUE_INVOICES.MAXIMUM_AMOUNT')}
                    margin={'dense'}
                  />
                </div>
              </div>
              <div className={drawerClasses.ClinicFilterHeader}>
                <b>{t('DUE_INVOICES.OPT_OUT_ELECTRONIC_STATEMENT')}</b>
                <Button
                  className={ClinicClasses.clearAll}
                  onClick={(): void => {
                    setOptOutStatement([]);
                  }}>
                  {t('COMMON.CLEAR_ALL')}
                </Button>
              </div>

              <div className={ClinicClasses.ClinicMenu}>
                {OPT_OUT_ELECTRONIC_STATEMENTS_FILTERS.map((filter: any, i) => (
                  <div
                    key={i}
                    className={drawerClasses.ClinicFilterHeaderLabels}>
                    <label
                      htmlFor={`opt-out-of-electronic-statements-filters-${i}`}>
                      {filter.label}
                    </label>
                    <Radio
                      id={`opt-out-of-electronic-statements-filters-${i}`}
                      data-test-id={`pcl-statements-optedOut-${i}`}
                      onClick={(): void => {
                        setOptOutStatement([filter]);
                      }}
                      checked={
                        !!selectedOptOutStatement.find(
                          (optOut: any) => optOut.label === filter.label
                        )
                      }
                    />
                  </div>
                ))}
              </div>
              <div className={drawerClasses.ClinicFilterHeader}>
                <b>{t('DUE_INVOICES.PLACEHOLDERS.STATEMENT_DUE_STATUS')}</b>
                <Button
                  className={ClinicClasses.clearAll}
                  onClick={(): void => {
                    setStatementDueStatus([]);
                  }}>
                  {t('COMMON.CLEAR_ALL')}
                </Button>
              </div>
              <div className={ClinicClasses.ClinicMenu}>
                {PAYMENT_FLOW_FILTERS.map((statementDueStatus: any, i) => (
                  <div
                    key={i}
                    className={drawerClasses.ClinicFilterHeaderLabels}>
                    <label htmlFor={`patient-activity-status-filters-${i}`}>
                      {t(statementDueStatus.label)}
                    </label>
                    <Radio
                      id={`patient-activity-status-filters-${i}`}
                      data-test-id={`pcl-statements-activityStatus-${i}`}
                      onClick={(): void => {
                        setStatementDueStatus([statementDueStatus]);
                      }}
                      checked={
                        !!selectedStatementDueStatus.find(
                          (sStatementDueStatus: any) =>
                            sStatementDueStatus.label ===
                            statementDueStatus.label
                        )
                      }
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </FilterDrawerComponent>
      }
      {showCopyUrl && (
        <ShowCopyLinkDialog
          downloadQRCodeTitle={`${
            clinicsList.find((clinic: any) =>
              selectedClinic.includes(clinic.id)
            )?.name
          } QR Code`}
          open={showCopyUrl}
          title={
            <Trans
              i18nKey={'PRACTICE.SHARE_CLINIC_URL_DIALOG.TITLE'}
              values={{
                practiceName:
                  clinicsList.find((clinic: any) =>
                    selectedClinic.includes(clinic.id)
                  )?.name ?? ''
              }}
              components={[<strong key={'X'} />]}
            />
          }
          subtitle={
            <Trans
              i18nKey={'PRACTICE.SHARE_CLINIC_URL_DIALOG.SUBTITLE'}
              values={{
                practiceName:
                  clinicsList.find((clinic: any) =>
                    selectedClinic.includes(clinic.id)
                  )?.name ?? ''
              }}
              components={[<strong key={'X'} />]}
            />
          }
          onClose={() => {
            setShowCopyUrl(false);
          }}
          copyText={formPracticePaymentLink(shortCode)}
        />
      )}
      {showConfirmationDialog && renderConfirmationDialog()}
    </div>
  );
};

export default PatientStatementsFilterComponent;
